import makeActionCreator from 'make-action-creator'

export const fetchMetrics = makeActionCreator('overview/fetchMetrics')
export const fetchRanking = makeActionCreator('overview/fetchRanking')